module.exports = __webpack_public_path__ + "static/media/buch_iiw_heuschrecken_seitlich.0e8971ca.jpg";